"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = supportsCaptureOption;
var cachedResult = null;

function supportsCaptureOption() {
  if (cachedResult === null) {
    var result = false;

    try {
      var opts = Object.defineProperty({}, 'capture', {
        get: function get() {
          result = true;
          return undefined;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {//ignore
    }

    cachedResult = result;
  }

  return cachedResult;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9zdXBwb3J0c0NhcHR1cmVPcHRpb24uanMiXSwibmFtZXMiOlsiY2FjaGVkUmVzdWx0Iiwic3VwcG9ydHNDYXB0dXJlT3B0aW9uIiwicmVzdWx0Iiwib3B0cyIsIk9iamVjdCIsImRlZmluZVByb3BlcnR5IiwiZ2V0IiwidW5kZWZpbmVkIiwid2luZG93IiwiYWRkRXZlbnRMaXN0ZW5lciIsImUiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUVBLElBQUlBLFlBQVksR0FBRyxJQUFuQjs7QUFFZSxTQUFTQyxxQkFBVCxHQUEwQztBQUN2RCxNQUFJRCxZQUFZLEtBQUssSUFBckIsRUFBMkI7QUFDekIsUUFBSUUsTUFBTSxHQUFHLEtBQWI7O0FBQ0EsUUFBSTtBQUNGLFVBQU1DLElBQUksR0FBSUMsTUFBRCxDQUFhQyxjQUFiLENBQTRCLEVBQTVCLEVBQWdDLFNBQWhDLEVBQTJDO0FBQ3REQyxRQUFBQSxHQURzRCxpQkFDaEQ7QUFDSkosVUFBQUEsTUFBTSxHQUFHLElBQVQ7QUFDQSxpQkFBT0ssU0FBUDtBQUNEO0FBSnFELE9BQTNDLENBQWI7QUFNQUMsTUFBQUEsTUFBTSxDQUFDQyxnQkFBUCxDQUF3QixNQUF4QixFQUFnQyxJQUFoQyxFQUFzQ04sSUFBdEM7QUFDRCxLQVJELENBUUUsT0FBT08sQ0FBUCxFQUFVLENBQ1Y7QUFDRDs7QUFDRFYsSUFBQUEsWUFBWSxHQUFHRSxNQUFmO0FBQ0Q7O0FBQ0QsU0FBT0YsWUFBUDtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiLyogQGZsb3cgKi9cblxubGV0IGNhY2hlZFJlc3VsdCA9IG51bGw7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHN1cHBvcnRzQ2FwdHVyZU9wdGlvbigpOiBib29sZWFuIHtcbiAgaWYgKGNhY2hlZFJlc3VsdCA9PT0gbnVsbCkge1xuICAgIGxldCByZXN1bHQgPSBmYWxzZTtcbiAgICB0cnkge1xuICAgICAgY29uc3Qgb3B0cyA9IChPYmplY3Q6YW55KS5kZWZpbmVQcm9wZXJ0eSh7fSwgJ2NhcHR1cmUnLCB7XG4gICAgICAgIGdldCgpIHtcbiAgICAgICAgICByZXN1bHQgPSB0cnVlO1xuICAgICAgICAgIHJldHVybiB1bmRlZmluZWQ7XG4gICAgICAgIH1cbiAgICAgIH0pO1xuICAgICAgd2luZG93LmFkZEV2ZW50TGlzdGVuZXIoJ3Rlc3QnLCBudWxsLCBvcHRzKTtcbiAgICB9IGNhdGNoIChlKSB7XG4gICAgICAvL2lnbm9yZVxuICAgIH1cbiAgICBjYWNoZWRSZXN1bHQgPSByZXN1bHQ7XG4gIH1cbiAgcmV0dXJuIGNhY2hlZFJlc3VsdDtcbn1cbiJdfQ==